import * as R from 'ramda'

export const addExpiresAt = (date, token) =>
  R.set(
    R.lensProp('expiresAt'),
    date
      .add({
        seconds: R.compose(
          R.subtract(R.__, 600),
          R.defaultTo(3600),
          R.prop('expiresIn'),
        )(token),
      })
      .unix(),
  )(token)
